var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mountain-area-navigation"},[_c('div',{staticClass:"flex-grid"},[(_vm.showMtnAreaNav)?_c('div',{staticClass:"col navigation-col"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }